module.exports = __webpack_public_path__ + "static/img/background.38811740.jpg";